import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { AnchorCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsDefaultLabels, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

@Component({
    selector: 'st-anchor-command-dialog',
    templateUrl: './anchor-command-dialog.html',
    styleUrls: ['./anchor-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-anchor-command-dialog' },
})
export class AnchorCommandDialogComponent {
    public ProductionFieldName = ProductionFieldName;
    public ProductionCommandsDefaultLabels = ProductionCommandsDefaultLabels;
    public command = input<AnchorCommand>();
    public commandChange = output<AnchorCommand>();
    public onEnterEmitter = output<AnchorCommand>();

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.ANCHOR);
        this.onEnterEmitter.emit(this.command());
    }
}
